import React, { ButtonHTMLAttributes, FC } from 'react';
import styled from '@xstyled/styled-components';
import BurgerIcon from '~/assets/icons/burger-btn-eds.svg';
import { t } from 'ttag';

type BurgerButtonEdsProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  'data-test-id'?: string | undefined;
};

const Button = styled.button`
  position: relative;
  box-sizing: border-box;
  width: 38px;
  height: 38px;
  border-radius: md;
  border: none;
  display: block;
  overflow: visible;
  background: ${p => p.theme.colors.accentDark};
  padding: 0;
  margin: 0;
  font-size: 0;
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: color-mix(in srgb, var(--color-accent-dk) 70%, white);
  }

  &:active:not(:disabled) {
    background-color: color-mix(in srgb, var(--color-accent-dk) 70%, black);
  }

  &:focus {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }

  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: md;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }

  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 28px;
    height: 28px;
  }
`;

const Burger = styled(BurgerIcon)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: block;
  width: 20px;
  height: 20px;

  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 16px;
    height: 16px;
  }
`;

export const BurgerButtonEds: FC<BurgerButtonEdsProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  'data-test-id': dataTestId,
  'aria-label': ariaLabel,
  ...props
}) => (
  <Button
    {...props}
    aria-label={ariaLabel ?? t`Open course navigation`}
    data-test-id={`${dataTestId || 'burger-button'}`}
  >
    <Burger aria-hidden="true" focusable="false" />
  </Button>
);
